import { IsNotEmpty } from "class-validator";

export class EnvApiKeyDto {
  @IsNotEmpty()
  name: string = "";

  @IsNotEmpty()
  description: string = "";
}
